// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import { Numeric, Currency } from 'common/components/Number';
import CampaignMetrics from 'common/modules/campaign/domain/CampaignMetrics';
import PrintingCard from 'common/modules/printing/styles/PrintingCard';
import { Metric, MetricTitle, MetricNumber } from 'common/modules/printing/styles/Metric';

import Campaign from '../../domain/Campaign';

const SCard = styled(PrintingCard)`
  margin-top: ${({ theme }) => theme.metrics.margin}px;
`;

type Props = {
  metrics: CampaignMetrics,
  campaign: Campaign,
  follo: boolean,

  t: any,
}

function MetricsListingCard(props: Props) {
  const { metrics, campaign, follo, t } = props;

  return (
    <SCard>
      <Metric>
        <MetricTitle>{t('impressions')}</MetricTitle>
        <MetricNumber>
          <Numeric
            roundAt={0}
            value={metrics.impressions}
          />
        </MetricNumber>
      </Metric>
      <Metric>
        <MetricTitle>{t('totalCost')}</MetricTitle>
        <MetricNumber>
          <Currency
            roundAt={2}
            value={campaign.totalCost}
          />
        </MetricNumber>
      </Metric>
      <Metric>
        <MetricTitle>{t(follo ? 'spotsBought' : 'spotsSold', { count: campaign.numberOfSpotsSold })}</MetricTitle>
        <MetricNumber>
          <Numeric
            roundAt={2}
            value={campaign.numberOfSpotsSold}
          />
        </MetricNumber>
      </Metric>
    </SCard>
  );
}

export default withTheme(translate('commonSales')(MetricsListingCard));



// WEBPACK FOOTER //
// ./src/common/modules/campaign/components/printing/MetricsListingCard.js